import module from 'contabilidad/polizasexternas/module'
import template from './template.html'

export class ContabilidadPolizasexternasAlgodonerosPagosComprasListaComponent {
  constructor($filter, $file) {
    this.$file = $file
    this.$filter = $filter
    this.verificarCadena = $filter('rPad')
  }

  $onInit() {
    this.provision = []
  }

  descargar() {
    let texto = this.codificar(1)
    let fecha = this.$filter('date')(new Date(), 'yyyyMMdd')
    let nombre = 'Provisionpagoscompras_' + fecha + '.txt'
    let blob = new File([texto], nombre, { type: 'text/plain' })
    this.$file.saveAs(blob, nombre)
  }

  codificar(inicio_poliza) {
    let cadena = '',
      cadA = 'P  AAAAMMDD    2      JJJJ 1 0          ' +
        'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX                                         11 1 0\r\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      * YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \r\n'
    let vuelta = -1
    this.data.forEach((movimiento, index) => {
      if (!movimiento.banco || !movimiento.bancoCuenta) return

      if (vuelta < index) {
        vuelta = index
        cadena += cadA
          .replace('AAAAMMDD', this.$filter('date')(movimiento.fecha, 'yyyyMMdd'))
          .replace('JJJJ', ('000' + (inicio_poliza + index)).slice(-4))
          .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', this.verificarCadena('Provision de pagos gastos ' + movimiento.banco + ' ' + movimiento.bancoCuenta + ' ' + movimiento.referencia, 60))
      }

      movimiento.detalles.forEach((detalle) => {
        if (detalle.importe != 0) {
          cadena += cadB
            .replace('CCCCCCCCCCCCCCCC', this.verificarCadena(detalle.cuentaContable.replace(/-/g, ''), 16))
            .replace('ZZZZZZZZZZZZZZZ', this.verificarCadena(detalle.factura, 15))
            .replace('*', detalle.naturaleza)
            .replace('YYYYYYYYY', this.verificarCadena((parseFloat(detalle.importe).toFixed(2)), 9))
            .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', this.verificarCadena(detalle.concepto, 43))
        }
      })
    })

    return cadena
  }

  filtrar() {
    this.provision = this.$filter('filter')(this.data.provision, this.filtro)
    this.pagos = this.$filter('filter')(this.data.pagos, this.filtro)
  }
}

module.component('contabilidadPolizasexternasAlgodonerosPagosComprasLista', {
  controller: ContabilidadPolizasexternasAlgodonerosPagosComprasListaComponent,
  template,
  bindings: {
    busqueda: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/components/algodoneros/pagos-compras/lista/component.js